import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {API_VERSIONS} from "../api-versions";
import {GeneralSettingModel} from "../../shared/models/general-setting.model";
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {NavbarItem} from "../../_metronic/layout/components/header/header-menu/model/navbar-item";
import {map} from "rxjs/operators";
import {TherapyEntity} from "../../shared/models/therapy-entity";
import {CompanyEntity} from "../../shared/models/company-entity";
import {Company} from "../../shared/models/company";
import {CategoriesEntity} from "../../shared/models/categories-entity";
import {Links} from "../../shared/models/links";

const API_GENERAL_URL = `${environment.apiUrl}/${API_VERSIONS.V1}/general`;

@Injectable({
  providedIn: 'root'
})
export class GeneralSettingsService {
  // @ts-ignore
  private generalSettingsSubject: BehaviorSubject<GeneralSettingModel> = new BehaviorSubject<GeneralSettingModel>(null);
  public generalSettings$ = this.generalSettingsSubject.asObservable();

  private menuItemsSubject: BehaviorSubject<NavbarItem[]> = new BehaviorSubject<NavbarItem[]>([]);
  public menuItems$ = this.menuItemsSubject.asObservable();

  constructor(private client: HttpClient) {
  }

  setGeneralSettings(generalSettings: GeneralSettingModel): void {
    this.generalSettingsSubject.next(generalSettings);
  }

  getGeneralTherapeutics(): Observable<TherapyEntity[]> {
    const therapeuticsRequestUrl = `${API_GENERAL_URL}/therapeutics`;
    return this.client.get<TherapyEntity[]>(therapeuticsRequestUrl).pipe(
      map((response: TherapyEntity[]) => {
        const therapyEntities: TherapyEntity[] = [];
        response.map((item) => therapyEntities.push(new TherapyEntity(item)));

        return therapyEntities;
      })
    );
  }

  getGeneralCompanies(): Observable<CompanyEntity[]> {
    const therapeuticsRequestUrl = `${API_GENERAL_URL}/companies`;
    return this.client.get<CompanyEntity[]>(therapeuticsRequestUrl).pipe(
      map((response: CompanyEntity[]) => {
        const companyEntities: CompanyEntity[] = [];
        response.map((item) => companyEntities.push(new CompanyEntity(item)));
        return companyEntities;
      })
    );
  }

  generalCompanies(therapeutics: number[]): Observable<CompanyEntity[]> {
    const therapeuticsRequestUrl = `${API_GENERAL_URL}/companies`;
    return this.client.post<CompanyEntity[]>(therapeuticsRequestUrl, {therapeutics: [therapeutics]}).pipe(
      map((response: CompanyEntity[]) => {
        const companyEntities: CompanyEntity[] = [];
        response.map((item) => companyEntities.push(new CompanyEntity(item)));
        return companyEntities;
      })
    );
  }

  generalCategories(company: Company): Observable<CategoriesEntity[]> {
    const categoriesRequestUrl = `${API_GENERAL_URL}/categories`;
    return this.client.post<CategoriesEntity[]>(categoriesRequestUrl, {
      therapeutics: company[`therapeutics`],
      companies: company[`companies`]
    }).pipe(map((response: CategoriesEntity[]) => {
      const categoriesEntity: CategoriesEntity[] = [];
      response.map((item) => categoriesEntity.push(new CategoriesEntity(item)))
      return categoriesEntity;
    }))
  }

  generalMenuItems(userId: number): Observable<NavbarItem[]> {
    const menuItemsRequestUrl = `${API_GENERAL_URL}/menuitems`;
    return this.client.post<NavbarItem[]>(menuItemsRequestUrl, {userId}).pipe(map(response => {
      this.menuItemsSubject.next(response);
      return response;
    }));
  }

  getGeneralSettings(): Observable<GeneralSettingModel> {
    const settingsRequestUrl = `${API_GENERAL_URL}/settings`;
    return this.client.get<GeneralSettingModel>(settingsRequestUrl).pipe(map((response: GeneralSettingModel) => {
        const generalSettings = new GeneralSettingModel(response);
        this.updateFavicon(generalSettings.logo)
        return generalSettings
      }
    ));
  }

  getGeneralLinks(): Observable<Links> {
    const linksRequestUrl = `${API_GENERAL_URL}/links`;
    return this.client.get<Links>(linksRequestUrl);
  }

  private updateFavicon(logo: string) {
    const favIcon: HTMLLinkElement = document.querySelector('#appIcon')!;
    favIcon.type = 'image/x-icon';
    favIcon.rel = 'icon';
    favIcon.href = logo;
  }
}
